import Splash from '@/assets/graphical-elements/splash.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const SplashIcon = ({className}: IconProps) => <Splash className={cn('fill-current', className)} />
